import uuid from 'uuid/v4';

import _get from 'lodash/get';

import { CONDITION_BY_TYPE, ACTION_BY_TYPE } from 'constants/rulesTypes';

export const setOrderIndex = (list, order) => {
  const el = list.find(el => el.order === order);
  return el ? el.index : order;
};

/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
export const createCopyRuleMatchingObj = (model, key, id) => {
  const { conditions, actions } = model;
  const matching_pattern_elements = [];

  model[key].forEach(item => {
    const matchId = uuid();

    conditions.map(condition => {
      const fieldName = CONDITION_BY_TYPE[condition.condition_type];

      if (condition[fieldName].matching_pattern_element === item.id) {
        condition[fieldName].matching_pattern_element = matchId;
      }

      return condition;
    });

    actions.forEach(action => {
      const fieldName = ACTION_BY_TYPE[action.action_type];

      if (item.id === action[fieldName].matching_pattern_element) {
        action[fieldName].matching_pattern_element = matchId;
      }

      if (['shift_action'].includes(fieldName)) {
        if (item.id === action[fieldName].matching_pattern_element_from) {
          action[fieldName].matching_pattern_element_from = matchId;
        }

        if (item.id === action[fieldName].matching_pattern_element_to) {
          action[fieldName].matching_pattern_element_to = matchId;
        }
      }

      if (['fill_action', 'mark_action'].includes(fieldName)) {
        action[fieldName].feature_values.map(value => {
          if (value.value_type === 'dynamic') {
            if (
              item.id ===
              _get(value, 'dynamic_value.source_matching_pattern_element', null)
            ) {
              value.dynamic_value.source_matching_pattern_element = matchId;
            }
          }

          if (value.value_type === 'concatenation') {
            value.concatenation_value.forEach(v => {
              if (v.source_matching_pattern_element === item.id) {
                v.source_matching_pattern_element = matchId;
              }
            });
          }

          return value;
        });

        if (fieldName === ACTION_BY_TYPE.mark_action) {
          if (action.mark_action.matching_pattern_element_from === item.id) {
            action[fieldName].matching_pattern_element_from = matchId;
          }

          if (action.mark_action.matching_pattern_element_to === item.id) {
            action.mark_action.matching_pattern_element_to = matchId;
          }
        }
      }
    });

    matching_pattern_elements.push({
      ...item,
      id: matchId,
      rule: id,
    });
  });

  return {
    conditions: conditions.reverse(),
    matching_pattern_elements,
    actions: actions.reverse(),
  };
};
